import TicketPdfPreview from "../ticket-pdf";
import { Modal } from "react-bootstrap";
import "./index.scss";

function TicketPdfPreviewModal({ ...props }) {
  const {
    setTicketLoader,
    printWindow,
    ticketLoader,
    onHide,
    rebars,
    orderNo,
    selectedRowCount,
    showStandardLogo,
  } = props;

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <TicketPdfPreview
        printWindow={printWindow}
        setTicketLoader={setTicketLoader}
        ticketLoader={ticketLoader}
        onHide={onHide}
        rebars={rebars}
        orderNo={orderNo}
        selectedRowCount={selectedRowCount}
        showStandardLogo={showStandardLogo}
      />
    </Modal>
  );
}

export default TicketPdfPreviewModal;